// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2hmwt","messages":"Chat_messages__6O7Ah","dateDivider":"Chat_dateDivider__1XA66"};